module.exports = __webpack_public_path__ + "static/img/mk83.c5a2405.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/mk83.jpg
// module id = KBgX
// module chunks = 0